import { tenantHelpers } from '../tenantInfo';

export const actionTypes = {
  UPDATE_TITLE: 'title.update-title',
  UPDATE_MESSAGE: 'title.update-message'
};

export function updateTitle(value) {
  const mainTitle = tenantHelpers.getProductName();
  var title = value ? mainTitle + ': ' + value : mainTitle;
  document.title = title;

  return {
    type: actionTypes.UPDATE_TITLE,
    value: title
  }
}

export function updateMessage(value) {
  return {
    type: actionTypes.UPDATE_MESSAGE,
    value
  }
}
